import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, Space, Modal, Drawer } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { useIntl, FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";
import { addLeadEmailAPI, editLeadEmailAPI } from "../LeadsAPI";
import AttachmentComponent from "CommonComponents/Attachments/Attachments";
import { useParams } from "react-router-dom";
import FormType from "features/Enums/FormType";

const { TextArea } = Input;

const LeadEmailForm = (props) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { leadId } = useParams();
  const intl = useIntl();
  const [loading, setLoading] = useState(false);
  const formTypeId = Object.values(FormType).find(
    (f) => f.name === "LeadEmails"
  )?.id;
  useEffect(() => {
    if (props?.email) {
      form.setFieldsValue({
        subject: props?.email.subject,
        bodyOfMail: props?.email.bodyOfMail,
      });
    } else {
      form.resetFields();
    }
  }, [props?.email, form]);
  const handleSubmit = async (values) => {
    const emailObj = {
      id: props?.email?.id || 0,
      leadId: leadId,
      subject: values.subject,
      bodyOfMail: values.bodyOfMail,
    };
    setLoading(true);
    const action = props?.email ? editLeadEmailAPI : addLeadEmailAPI;
    await dispatch(action(emailObj, leadId));
    form.resetFields();
    props?.onClose();
    setLoading(false);
  };
  const onCancel = () => {
    if (form.isFieldsTouched()) {
      Modal.confirm({
        title: intl.formatMessage({ id: "LeadNote.CancelConfirmation" }),
        okText: intl.formatMessage({ id: "Common.Yes" }),
        cancelText: intl.formatMessage({ id: "Common.No" }),
        onOk: () => {
          form.resetFields();
          props?.onClose();
        },
      });
    } else {
      props?.onClose();
    }
  };

  return (
    <Drawer
      open={props?.drawerVisible}
      onClose={props?.onClose}
      width={500}
      title={
        props?.email ? (
          <FormattedMessage id="LeadMail.EditLeadMail" />
        ) : (
          <FormattedMessage id="LeadMail.AddNewMail" />
        )
      }
    >
      <Form
        form={form}
        layout="vertical"
        size="large"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          label={<FormattedMessage id="LeadMail.Subject" />}
          name="subject"
          rules={[
            {
              required: true,
              message: intl.formatMessage({
                id: "LeadMail.Error.PleaseEntersubject",
              }),
            },
          ]}
        >
          <Input
            placeholder={intl.formatMessage({
              id: "LeadMail.Placeholder.Entersubject",
            })}
            maxLength={200}
          />
        </Form.Item>

        <Form.Item
          label={<FormattedMessage id="LeadMail.BodyMail" />}
          name="bodyOfMail"
          rules={[
            {
              required: true,
              message: intl.formatMessage({
                id: "LeadMail.Error.PleaseEnterbodyMail",
              }),
            },
          ]}
        >
          <TextArea
            rows={4}
            maxLength={255}
            showCount
            placeholder={intl.formatMessage({
              id: "LeadMail.Placeholder.EnterbodyMail",
            })}
          />
        </Form.Item>

        <Form.Item label={<FormattedMessage id="Common.Attachment" />}>
          <AttachmentComponent
            identifier={formTypeId}
            currentId={props?.email ? props?.email?.id : null}
            getattachments={true}
          />
        </Form.Item>

        <Row justify="center" className="mt-10">
          <Space>
            <Button
              danger
              onClick={onCancel}
              icon={<CloseCircleOutlined />}
              disabled={loading}
            >
              <FormattedMessage id="Common.Cancel" />
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              icon={<CheckCircleOutlined />}
              loading={loading}
            >
              <FormattedMessage id="Common.Save" />
            </Button>
          </Space>
        </Row>
      </Form>
    </Drawer>
  );
};

export default LeadEmailForm;
